<div class="grid">
	<div class="col-12">
		<div class="card docs">
			<h4>Current Version</h4>
			<p>Angular 13 and PrimeNG 13</p>

			<h4>Dependencies</h4>
			<p>
				Verona has no direct dependency. More information about dependencies is available at
				<a href="https://www.primefaces.org/why-primeng-templates/">Why PrimeNG Templates</a>
				article.
			</p>

			<h4>Getting Started</h4>
			<p>
				Verona is a true native application template for Angular and is distributed as a CLI project. In case
				CLI is not installed already, use the command below to set it up.
			</p>

			<app-code ngPreserveWhitespaces ngNonBindable lang="markup"> npm install -g @angular/cli </app-code>

			<p>
				Once CLI is ready in your system, extract the contents of the Verona zip file distribution, cd to the
				directory, install the libraries from npm and then execute "ng serve" to run the application in your
				local environment.
			</p>
			<app-code ngPreserveWhitespaces ngNonBindable lang="markup"> cd verona npm install ng serve </app-code>

			<p>
				The application should run at http://localhost:4200/, you may now start with the development of your
				application.
			</p>

			<h4>Important CLI Commands</h4>
			<p>Following commands are derived from CLI.</p>
			<app-code ngPreserveWhitespaces ngNonBindable lang="markup">
				Run 'ng serve' for a dev server. Navigate to `http://localhost:4200/`. The app will automatically reload
				if you change any of the source files. Run 'ng generate component component-name' to generate a new
				component. You can also use `ng generate directive/pipe/service/class/module`. Run 'ng build' to build
				the project. The build artifacts will be stored in the `dist/` directory. Use the `-prod` flag for a
				production build. Run 'ng test' to execute the unit tests via [Karma](https://karma-runner.github.io).
				Run 'ng e2e' to execute the end-to-end tests via [Protractor](http://www.protractortest.org/). Run 'ng
				help' for more options.
			</app-code>

			<h4>Structure</h4>
			<p>
				Verona consists of 3 main parts; the application layout, layout resources and theme resources for
				PrimeNG components.
				<i>app.main.component.html</i> inside app folder is the html template for the base layout, required
				resources for the layout are placed inside the <i>src/assets/layout</i> folder and similarly theme
				resources are inside <i>src/assets/theme</i> folder.
			</p>

			<h4>Template</h4>
			<p>
				Main layout is the html view of the app.main.component.ts, it is divided into a couple of sections such
				as topbar, profile, menu and footer. Here is the code for the main template. The component class
				app.main.component.ts implements the logic such as opening menus, managing layout modes and so on.
			</p>
			<app-code ngPreserveWhitespaces ngNonBindable>
				&lt;div class=&quot;layout-wrapper&quot; [ngClass]=&quot;&#123;&#39;layout-slim&#39;: app.menuMode ===
				&#39;slim&#39;, &#39;layout-static&#39;: app.menuMode === &#39;static&#39;,
				&#39;layout-mobile-active&#39;: staticMenuMobileActive, &#39;layout-static-inactive&#39;:
				staticMenuDesktopInactive &amp;&amp; app.menuMode === &#39;static&#39;, &#39;p-input-filled&#39;:
				app.inputStyle === &#39;filled&#39;, &#39;p-ripple-disabled&#39;: !app.ripple&#125;&quot;
				(click)=&quot;onLayoutClick()&quot;&gt; &lt;app-topbar&gt;&lt;/app-topbar&gt;
				&lt;app-menu&gt;&lt;/app-menu&gt; &lt;div class=&quot;layout-content-wrapper&quot;&gt; &lt;div
				class=&quot;layout-content&quot;&gt; &lt;router-outlet&gt;&lt;/router-outlet&gt; &lt;/div&gt;
				&lt;app-footer&gt;&lt;/app-footer&gt; &lt;/div&gt; &lt;app-config&gt;&lt;/app-config&gt; &lt;/div&gt;
			</app-code>

			<h4>Menu</h4>
			<p>
				Menu is a separate component defined in app.menu.component.ts file based on PrimeNG MenuModel API. In
				order to define the menuitems, navigate to this file and define your own model as a nested structure.
				Here is the menu component from the sample application.
			</p>
			<div style="height: 400px; overflow: auto">
				<app-code ngPreserveWhitespaces ngNonBindable lang="javascript">
					import &#123;Component, OnInit&#125; from '@angular/core'; import &#123;AppComponent&#125; from
					'./app.component'; @Component(&#123; selector: 'app-menu', templateUrl: './app.menu.component.html'
					&#125;) export class AppMenuComponent implements OnInit &#123; model: any[]; constructor(public app:
					AppComponent) &#123;&#125; ngOnInit() &#123; this.model = [ &#123; label: 'Dashboard', icon: 'pi
					pi-home', items: [ &#123;label: 'Sales', icon: 'pi pi-desktop', routerLink: ['/']&#125;,
					&#123;label: 'Analytics', icon: 'pi pi-chart-bar', routerLink: ['/analytics']&#125; ] &#125;, &#123;
					label: 'UI Kit', icon: 'pi pi-star', routerLink: ['/uikit'], items: [ &#123;label: 'Form Layout',
					icon: 'pi pi-id-card', routerLink: ['/uikit/formlayout']&#125;, &#123;label: 'Input', icon: 'pi
					pi-check-square', routerLink: ['/uikit/input']&#125;, &#123;label: 'Float Label', icon: 'pi
					pi-bookmark', routerLink: ['/uikit/floatlabel']&#125;, &#123;label: 'Invalid State', icon: 'pi
					pi-exclamation-circle', routerLink: ['/uikit/invalidstate']&#125;, &#123;label: 'Button', icon: 'pi
					pi-mobile', routerLink: ['/uikit/button'], class: 'rotated-icon'&#125;, &#123;label: 'Table', icon:
					'pi pi-table', routerLink: ['/uikit/table']&#125;, &#123;label: 'List', icon: 'pi pi-list',
					routerLink: ['/uikit/list']&#125;, &#123;label: 'Tree', icon: 'pi pi-share-alt', routerLink:
					['/uikit/tree']&#125;, &#123;label: 'Panel', icon: 'pi pi-tablet', routerLink:
					['/uikit/panel']&#125;, &#123;label: 'Overlay', icon: 'pi pi-clone', routerLink:
					['/uikit/overlay']&#125;, &#123;label: 'Media', icon: 'pi pi-image', routerLink:
					['/uikit/media']&#125;, &#123;label: 'Menu', icon: 'pi pi-bars', routerLink: ['/uikit/menu']&#125;,
					&#123;label: 'Message', icon: 'pi pi-comment', routerLink: ['/uikit/message']&#125;, &#123;label:
					'File', icon: 'pi pi-file', routerLink: ['/uikit/file']&#125;, &#123;label: 'Chart', icon: 'pi
					pi-chart-bar', routerLink: ['/uikit/charts']&#125;, &#123;label: 'Misc', icon: 'pi pi-circle-off',
					routerLink: ['/uikit/misc']&#125; ] &#125;, &#123; label: 'Utilities', icon: 'pi pi-compass',
					routerLink: ['utilities'], items: [ &#123;label: 'Display', icon: 'pi pi-desktop', routerLink:
					['utilities/display']&#125;, &#123;label: 'Elevation', icon: 'pi pi-external-link', routerLink:
					['utilities/elevation']&#125;, &#123;label: 'FlexBox', icon: 'pi pi-directions', routerLink:
					['utilities/flexbox']&#125;, &#123;label: 'Icons', icon: 'pi pi-search', routerLink:
					['utilities/icons']&#125;, &#123;label: 'Text', icon: 'pi pi-pencil', routerLink:
					['utilities/text']&#125;, &#123;label: 'Widgets', icon: 'pi pi-star', routerLink:
					['utilities/widgets']&#125;, &#123;label: 'Grid System', icon: 'pi pi-th-large', routerLink:
					['utilities/grid']&#125;, &#123;label: 'Spacing', icon: 'pi pi-arrow-right', routerLink:
					['utilities/spacing']&#125;, &#123;label: 'Typography', icon: 'pi pi-align-center', routerLink:
					['utilities/typography']&#125; ] &#125;, &#123; label: 'Pages', icon: 'pi pi-briefcase', routerLink:
					['/pages'], items: [ &#123;label: 'Crud', icon: 'pi pi-pencil', routerLink: ['/pages/crud']&#125;,
					&#123;label: 'Calendar', icon: 'pi pi-calendar-plus', routerLink: ['/pages/calendar']&#125;,
					&#123;label: 'Timeline', icon: 'pi pi-calendar', routerLink: ['/pages/timeline']&#125;, &#123;label:
					'Landing', icon: 'pi pi-globe', url: 'assets/pages/landing.html', target: '_blank'&#125;,
					&#123;label: 'Login', icon: 'pi pi-sign-in', routerLink: ['/login']&#125;, &#123;label: 'Invoice',
					icon: 'pi pi-dollar', routerLink: ['/pages/invoice']&#125;, &#123;label: 'Help', icon: 'pi
					pi-question-circle', routerLink: ['/pages/help']&#125;, &#123;label: 'Error', icon: 'pi
					pi-times-circle', routerLink: ['/error']&#125;, &#123;label: 'Not Found', icon: 'pi
					pi-exclamation-circle', routerLink: ['/notfound']&#125;, &#123;label: 'Access Denied', icon: 'pi
					pi-lock', routerLink: ['/access']&#125;, &#123;label: 'Empty', icon: 'pi pi-circle-off', routerLink:
					['/pages/empty']&#125; ] &#125;, &#123; label: 'Hierarchy', icon: 'pi pi-align-left', items: [
					&#123; label: 'Submenu 1', icon: 'pi pi-align-left', items: [ &#123; label: 'Submenu 1.1', icon: 'pi
					pi-align-left', items: [ &#123;label: 'Submenu 1.1.1', icon: 'pi pi-align-left'&#125;, &#123;label:
					'Submenu 1.1.2', icon: 'pi pi-align-left'&#125;, &#123;label: 'Submenu 1.1.3', icon: 'pi
					pi-align-left'&#125;, ] &#125;, &#123; label: 'Submenu 1.2', icon: 'pi pi-align-left', items: [
					&#123;label: 'Submenu 1.2.1', icon: 'pi pi-align-left'&#125; ] &#125;, ] &#125;, &#123; label:
					'Submenu 2', icon: 'pi pi-align-left', items: [ &#123; label: 'Submenu 2.1', icon: 'pi
					pi-align-left', items: [ &#123;label: 'Submenu 2.1.1', icon: 'pi pi-align-left'&#125;, &#123;label:
					'Submenu 2.1.2', icon: 'pi pi-align-left'&#125;, ] &#125;, &#123; label: 'Submenu 2.2', icon: 'pi
					pi-align-left', items: [ &#123;label: 'Submenu 2.2.1', icon: 'pi pi-align-left'&#125;, ] &#125;, ]
					&#125; ] &#125;, &#123; label: 'Start', icon: 'pi pi-download', items: [ &#123; label: 'Buy Now',
					icon: 'pi pi-shopping-cart', url: ['https://www.primefaces.org/store'] &#125;, &#123; label:
					'Documentation', icon: 'pi pi-info-circle', routerLink: ['/documentation'] &#125; ] &#125; ]; &#125;
					&#125;
				</app-code>
			</div>

			<h4>Integration with an Existing CLI Project</h4>
			<p>
				To setup verona in an existing project, copy the
				<i>src/assets</i> folder to your projects folder with the same name and replace the contents of
				app.component.ts, app.component.html with their counterparts in verona under <i>src/app</i> folder.
			</p>

			<p>Install PrimeNG</p>
			<app-code ngPreserveWhitespaces ngNonBindable lang="markup">
				npm install primeng@latest --save npm install primeicons@latest --save
			</app-code>

			<p>Add PrimeNG CSS at styles section in angular.json.</p>

			<app-code ngPreserveWhitespaces ngNonBindable lang="json">
				"styles": [ "styles.scss" //your styles and overrides ],
			</app-code>

			<p>
				Last part is adding theme and layout css files, in the CLI app they are defined using link tags in
				index.html so the demo can switch them on the fly by changing the path however if this is not a
				requirement, you may also add them to the styles configuration so they go inside the bundle.
			</p>

			<h4 id="noncli">Integration with an Existing Non-CLI Project</h4>
			<p>
				For an existing project that do not use CLI, setup steps are more or less similar. Start with installing
				the dependencies listed above in package.json
			</p>
			<p>
				Copy the <i>src/assets</i> folder to your application and include the resources listed above with a
				module bundler like webpack or using link-script tags.
			</p>
			<p>
				Finally copy the contents of app.component.html to your application's main component template such as
				<i>app/application.html</i> along with the sub components which are app.menu.component.ts,
				app.profile.components.ts, app.topbar.component.ts and app.footer.component.ts.
			</p>

			<h4>Theme</h4>
			<p>
				Verona provides 7 PrimeNG themes out of the box, setup of a theme is simple by including the css of
				theme to your bundle that are located inside resources/theme folder.
			</p>

			<ul>
				<li>theme-amber</li>
				<li>theme-blue</li>
				<li>theme-bluegrey</li>
				<li>theme-green</li>
				<li>theme-purple</li>
				<li>theme-teal</li>
				<li>theme-turquoise</li>
			</ul>

			<p>A custom theme can be developed by the following steps.</p>
			<ul>
				<li>Choose a custom theme name such as theme-myown.</li>
				<li>
					Create a file named theme-myown.scss under
					<i>assets/theme folder</i>.
				</li>
				<li>
					Define the variables listed below and import the
					<i>/sass/theme/_theme.scss</i> file.
				</li>
				<li>Build the scss to generate css</li>
				<li>Include the generated theme.css to your page.</li>
			</ul>

			<p>
				Here are the variables required to create a theme, you may need to change the last line according to the
				relative path of the sass folder in your application.
			</p>

			<app-code ngPreserveWhitespaces ngNonBindable lang="css">
				$primaryColor: #3ebaf8; $primaryLightColor: scale-color($primaryColor, $lightness: 60%) !default;
				$primaryDarkColor: scale-color($primaryColor, $lightness: -10%) !default; $primaryDarkerColor:
				scale-color($primaryColor, $lightness: -20%) !default; $primaryTextColor: #ffffff; $highlightBg:
				$primaryColor; $highlightTextColor: $primaryTextColor; @import '../sass/theme/_theme';
			</app-code>

			<p>An example sass command to compile the css would be;</p>

			<app-code ngPreserveWhitespaces ngNonBindable lang="markup">
				sass src/assets/theme/theme-myown.scss src/assets/theme/theme-myown.css
			</app-code>

			<p>
				Watch mode is handy to avoid compiling everytime when a change is made, instead use the following
				command so that sass generates the file whenever you make a customization. This builds all css files
				whenever a change is made to any scss file.
			</p>
			<app-code ngPreserveWhitespaces ngNonBindable lang="markup">
				sass --watch src/:src/ --no-source-map
			</app-code>

			<p>Same can also be applied to layout itself;</p>
			<ul>
				<li>Choose a layout name such as layout-myown.</li>
				<li>
					Create an empty file named layout-myown.scss inside
					<i>assets/layout/css</i> folder.
				</li>
				<li>
					Define the variables listed below and import the
					<i>/sass/layout/_layout.scss</i> file.
				</li>
				<li>Build the scss to generate css</li>
				<li>Serve the css by importing it using a link tag or a bundler.</li>
			</ul>

			<p>
				Here are the variables required to create a layout, you may need to change the last line according to
				the relative path of the sass folder in your application.
			</p>

			<app-code ngPreserveWhitespaces ngNonBindable lang="css">
				$bodyBg: linear-gradient(147.38deg, #FFFFFF 0%, #86A8C0 100%); //menu $menuButtonMobileBg:
				linear-gradient(147.38deg, #FFFFFF 0%, #86A8C0 100%); $menuitemRootTextColor: #6c757d;
				$menuitemTextColor: #495057; $menuitemHoverBg: #e9ecef; $menuitemSubmenuBg: #e9ecef; $menuitemActiveBg:
				#D9E2EC; $menuitemTextActiveColor: #3E4C59; $menuitemFocusShadow: 0 0 0 0.2rem rgba(255,255,255,0.1);
				$slimSubMenuBg: linear-gradient(0deg, rgba(255,255,255, 0.5), rgba(255,255,255, 0.5)),
				linear-gradient(147.38deg, #FFFFFF 0%, #86A8C0 100%); //topbar $topbarMenuTextColor: rgba(123, 135, 148,
				1); $topbarMenuTextActiveColor: rgba(62, 76, 89, 1); $topbarTextColor: rgba(62, 76, 89, 1);
				$topbarSecondaryTextColor: #7B8794; $topbarArrowButtonBg: rgba(62, 76, 89, 1);
				$topbarArrowButtonTextColor: #FFFFFF; $topbarItemsBg: rgba(220, 230, 237, 0.1); $topbarItemsBorder: 2px
				solid #829AB1; $topbarAvatarBg: rgba(188, 204, 220, 1); $topbarAvatarTextColor: #3E4C59;
				$topbarIconHoverBg: #e9ecef !default; //footer $footerTextColor: rgba(62, 76, 89, 1) !default; @import
				'../../sass/layout/_layout_light';
			</app-code>

			<h4>Common SASS Variables</h4>
			<p>
				In case you'd like to customize the shared variables, the _variables.scss files are where the options
				are defined for layout and theme.
			</p>

			<h5>sass/variables/layout/_common.scss</h5>
			<app-code ngPreserveWhitespaces ngNonBindable lang="css">
				//general $fontSize:14px !default; $fontFamily:'Lato', Helvetica, sans-serif !default;
				$transitionDuration:.2s !default; $animationDuration:.4s !default;
				$animationTimingFunction:cubic-bezier(.05,.74,.2,.99) !default; $letterSpacing:normal !default;
				$borderRadius:4px !default; $tabletBreakpoint:991px !default; $phoneBreakpoint:576px !default; //sidebar
				$sidebarWidth: 14rem !default; $slimSidebarWidth: 7rem !default;
			</app-code>

			<h5>sass/variables/theme/_theme_light.scss</h5>
			<div style="height: 400px; overflow: auto">
				<app-code ngPreserveWhitespaces ngNonBindable lang="css">
					$colors: ( "blue": #54B0F3, "green": #29C76F, "yellow": #F3D054, "cyan": #3EC9D6, "pink": #EA5455,
					"indigo": #5464F3, "teal": #0DC381, "orange": #FF9F42, "bluegray": #6878A0, "purple": #7254F3 )
					!default; //reused color variables $shade000:#ffffff !default; //surface $shade100:#eff3f8 !default;
					//header background $shade200:#f6f9fc !default; //hover background $shade300:#dfe7ef !default;
					//border, divider $shade400:#d3dbe3 !default; //input border $shade500:#c6ccd7 !default; //input
					icon $shade600:#708da9 !default; //text secondary color $shade700:#043d75 !default; //text color
					$shade800:#343a40 !default; //unused $shade900:#212529 !default; //unused //global $fontFamily:Lato,
					Helvetica, sans-serif !default; $fontSize:1rem !default; $fontWeight:normal !default;
					$textColor:$shade700 !default; $textSecondaryColor:$shade600 !default; $borderRadius:6px !default;
					$transitionDuration:.2s !default; $formElementTransition:background-color $transitionDuration, color
					$transitionDuration, border-color $transitionDuration, box-shadow $transitionDuration !default;
					$actionIconTransition:background-color $transitionDuration, color $transitionDuration, box-shadow
					$transitionDuration !default; $listItemTransition:box-shadow $transitionDuration !default;
					$primeIconFontSize:1rem !default; $divider:1px solid $shade300 !default; $inlineSpacing:.5rem
					!default; $disabledOpacity:.6 !default; $maskBg:rgba(0, 0, 0, 0.4) !default;
					$loadingIconFontSize:2rem !default; $errorColor:#ff6767 !default; //scale $scaleSM:0.875 !default;
					$scaleLG:1.25 !default; //focus $focusOutlineColor:$primaryLightColor !default; $focusOutline:0 none
					!default; $focusOutlineOffset:0 !default; $focusShadow:0 0 0 1px $focusOutlineColor !default;
					//action icons $actionIconWidth:2rem !default; $actionIconHeight:2rem !default;
					$actionIconBg:transparent !default; $actionIconBorder:0 none !default; $actionIconColor:$shade600
					!default; $actionIconHoverBg:$shade200 !default; $actionIconHoverBorderColor:transparent !default;
					$actionIconHoverColor:$shade700 !default; $actionIconBorderRadius:50% !default; //input field (e.g.
					inputtext, spinner, inputmask) $inputPadding:.75rem .75rem !default; $inputTextFontSize:1rem
					!default; $inputBg:$shade000 !default; $inputTextColor:$shade700 !default; $inputIconColor:$shade600
					!default; $inputBorder:1px solid $shade400 !default; $inputHoverBorderColor:$primaryColor !default;
					$inputFocusBorderColor:$primaryColor !default; $inputErrorBorderColor:$errorColor !default;
					$inputPlaceholderTextColor:$shade600 !default; $inputFilledBg:$shade200 !default;
					$inputFilledHoverBg:$inputFilledBg !default; $inputFilledFocusBg:$shade000 !default; //input groups
					$inputGroupBg:$shade200 !default; $inputGroupTextColor:$shade600 !default; $inputGroupAddOnMinWidth:
					3rem !default; //input lists (e.g. dropdown, autocomplete, multiselect, orderlist)
					$inputListBg:$shade000 !default; $inputListTextColor:$shade700 !default;
					$inputListBorder:$inputBorder !default; $inputListPadding:.75rem 0 !default;
					$inputListItemPadding:.75rem 1.25rem !default; $inputListItemBg:transparent !default;
					$inputListItemTextColor:$shade700 !default; $inputListItemHoverBg:$shade200 !default;
					$inputListItemTextHoverColor:$shade700 !default; $inputListItemBorder:0 none !default;
					$inputListItemBorderRadius:0 !default; $inputListItemMargin:0 !default;
					$inputListItemFocusShadow:inset 0 0 0 1px $focusOutlineColor !default;
					$inputListHeaderPadding:.75rem 1.25rem !default; $inputListHeaderMargin:0 !default;
					$inputListHeaderBg:$shade100 !default; $inputListHeaderTextColor:$shade600 !default;
					$inputListHeaderBorder:1px solid $shade300 !default; //inputs with overlays (e.g. autocomplete,
					dropdown, multiselect) $inputOverlayBg:$inputListBg !default;
					$inputOverlayHeaderBg:$inputListHeaderBg !default; $inputOverlayBorder:0 none !default;
					$inputOverlayShadow:0 2px 12px 0 rgba(0,0,0,.1) !default; //password $passwordMeterBg:$shade300
					!default; $passwordWeakBg:#ea5455 !default; $passwordMediumBg:#ff9f42 !default;
					$passwordStrongBg:#29c76f !default; //button $buttonPadding:.75rem 1.25rem !default;
					$buttonIconOnlyWidth:3rem !default; $buttonIconOnlyPadding:.75rem 0 !default;
					$buttonBg:$primaryColor !default; $buttonTextColor:$primaryTextColor !default; $buttonBorder:1px
					solid $primaryColor !default; $buttonHoverBg:$primaryDarkColor !default;
					$buttonTextHoverColor:$primaryTextColor !default; $buttonHoverBorderColor:$primaryDarkColor
					!default; $buttonActiveBg:$primaryDarkerColor !default; $buttonTextActiveColor:$primaryTextColor
					!default; $buttonActiveBorderColor:$primaryDarkerColor !default; $raisedButtonShadow:0 3px 1px -2px
					rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !default;
					$roundedButtonBorderRadius:2rem !default; $textButtonHoverBgOpacity:.04 !default;
					$textButtonActiveBgOpacity:.16 !default; $outlinedButtonBorder:1px solid !default;
					$plainButtonTextColor:$textSecondaryColor !default; $plainButtonHoverBgColor:$shade200 !default;
					$plainButtonActiveBgColor:$shade300 !default; $secondaryButtonBg:#a1c30d !default;
					$secondaryButtonTextColor:#ffffff !default; $secondaryButtonBorder:1px solid $secondaryButtonBg
					!default; $secondaryButtonHoverBg:scale-color($secondaryButtonBg, $lightness: -10%) !default;
					$secondaryButtonTextHoverColor:$secondaryButtonTextColor !default;
					$secondaryButtonHoverBorderColor:scale-color($secondaryButtonBg, $lightness: -10%) !default;
					$secondaryButtonActiveBg:scale-color($secondaryButtonBg, $lightness: -20%) !default;
					$secondaryButtonTextActiveColor:$secondaryButtonTextColor !default;
					$secondaryButtonActiveBorderColor:scale-color($secondaryButtonBg, $lightness: -20%) !default;
					$secondaryButtonFocusShadow:0 0 0 0.2rem scale-color($secondaryButtonBg, $lightness: 60%) !default;
					$infoButtonBg:#5486f3 !default; $infoButtonTextColor:#ffffff !default; $infoButtonBorder:1px solid
					$infoButtonBg !default; $infoButtonHoverBg:scale-color($infoButtonBg, $lightness: -10%) !default;
					$infoButtonTextHoverColor:$infoButtonTextColor !default;
					$infoButtonHoverBorderColor:scale-color($infoButtonBg, $lightness: -10%) !default;
					$infoButtonActiveBg:scale-color($infoButtonBg, $lightness: -20%) !default;
					$infoButtonTextActiveColor:$infoButtonTextColor !default;
					$infoButtonActiveBorderColor:scale-color($infoButtonBg, $lightness: -20%) !default;
					$infoButtonFocusShadow:0 0 0 0.2rem scale-color($infoButtonBg, $lightness: 60%) !default;
					$successButtonBg:#29c76f !default; $successButtonTextColor:#ffffff !default;
					$successButtonBorder:1px solid $successButtonBg !default;
					$successButtonHoverBg:scale-color($successButtonBg, $lightness: -10%) !default;
					$successButtonTextHoverColor:$successButtonTextColor !default;
					$successButtonHoverBorderColor:scale-color($successButtonBg, $lightness: -10%) !default;
					$successButtonActiveBg:scale-color($successButtonBg, $lightness: -20%) !default;
					$successButtonTextActiveColor:$successButtonTextColor !default;
					$successButtonActiveBorderColor:scale-color($successButtonBg, $lightness: -20%) !default;
					$successButtonFocusShadow:0 0 0 0.2rem scale-color($successButtonBg, $lightness: 60%) !default;
					$warningButtonBg:#ff9f42 !default; $warningButtonTextColor:#ffffff !default;
					$warningButtonBorder:1px solid $warningButtonBg !default;
					$warningButtonHoverBg:scale-color($warningButtonBg, $lightness: -10%) !default;
					$warningButtonTextHoverColor:$warningButtonTextColor !default;
					$warningButtonHoverBorderColor:scale-color($warningButtonBg, $lightness: -10%) !default;
					$warningButtonActiveBg:scale-color($warningButtonBg, $lightness: -20%) !default;
					$warningButtonTextActiveColor:$warningButtonTextColor !default;
					$warningButtonActiveBorderColor:scale-color($warningButtonBg, $lightness: -20%) !default;
					$warningButtonFocusShadow:0 0 0 0.2rem scale-color($warningButtonBg, $lightness: 60%) !default;
					$helpButtonBg:#3ec9d6 !default; $helpButtonTextColor:#ffffff !default; $helpButtonBorder:1px solid
					$helpButtonBg !default; $helpButtonHoverBg:scale-color($helpButtonBg, $lightness: -10%) !default;
					$helpButtonTextHoverColor:$helpButtonTextColor !default;
					$helpButtonHoverBorderColor:scale-color($helpButtonBg, $lightness: -10%) !default;
					$helpButtonActiveBg:scale-color($helpButtonBg, $lightness: -20%) !default;
					$helpButtonTextActiveColor:$helpButtonTextColor !default;
					$helpButtonActiveBorderColor:scale-color($helpButtonBg, $lightness: -20%) !default;
					$helpButtonFocusShadow:0 0 0 0.2rem scale-color($helpButtonBg, $lightness: 60%) !default;
					$dangerButtonBg:#ea5455 !default; $dangerButtonTextColor:#ffffff !default; $dangerButtonBorder:1px
					solid $dangerButtonBg !default; $dangerButtonHoverBg:scale-color($dangerButtonBg, $lightness: -10%)
					!default; $dangerButtonTextHoverColor:$dangerButtonTextColor !default;
					$dangerButtonHoverBorderColor:scale-color($dangerButtonBg, $lightness: -10%) !default;
					$dangerButtonActiveBg:scale-color($dangerButtonBg, $lightness: -20%) !default;
					$dangerButtonTextActiveColor:$dangerButtonTextColor !default;
					$dangerButtonActiveBorderColor:scale-color($dangerButtonBg, $lightness: -20%) !default;
					$dangerButtonFocusShadow:0 0 0 0.2rem scale-color($dangerButtonBg, $lightness: 60%) !default;
					$linkButtonColor:$primaryDarkerColor !default; $linkButtonHoverColor:$primaryDarkerColor !default;
					$linkButtonTextHoverDecoration:underline !default; $linkButtonFocusShadow:0 0 0 0.2rem
					$focusOutlineColor !default; //checkbox $checkboxWidth:22px !default; $checkboxHeight:22px !default;
					$checkboxBorder:2px solid $shade400 !default; $checkboxIconFontSize:14px !default;
					$checkboxActiveBorderColor:$primaryColor !default; $checkboxActiveBg:$primaryColor !default;
					$checkboxIconActiveColor:$primaryTextColor !default; $checkboxActiveHoverBg:$primaryDarkerColor
					!default; $checkboxIconActiveHoverColor:$primaryTextColor !default;
					$checkboxActiveHoverBorderColor:$primaryDarkerColor !default; //radiobutton $radiobuttonWidth:22px
					!default; $radiobuttonHeight:22px !default; $radiobuttonBorder:2px solid $shade400 !default;
					$radiobuttonIconSize:12px !default; $radiobuttonActiveBorderColor:$primaryColor !default;
					$radiobuttonActiveBg:$primaryColor !default; $radiobuttonIconActiveColor:$primaryTextColor !default;
					$radiobuttonActiveHoverBg:$primaryDarkerColor !default;
					$radiobuttonIconActiveHoverColor:$primaryTextColor !default;
					$radiobuttonActiveHoverBorderColor:$primaryDarkerColor !default; //colorpicker
					$colorPickerPreviewWidth:2rem !default; $colorPickerPreviewHeight:2rem !default;
					$colorPickerBg:#323232 !default; $colorPickerBorderColor:#191919 !default;
					$colorPickerHandleColor:$shade000 !default; //togglebutton $toggleButtonBg:$inputBg !default;
					$toggleButtonBorder:1px solid $shade400 !default; $toggleButtonTextColor:$shade700 !default;
					$toggleButtonIconColor:$shade600 !default; $toggleButtonHoverBg:$shade200 !default;
					$toggleButtonHoverBorderColor:$shade400 !default; $toggleButtonTextHoverColor:$shade700 !default;
					$toggleButtonIconHoverColor:$shade600 !default; $toggleButtonActiveBg:$primaryColor !default;
					$toggleButtonActiveBorderColor:$primaryColor !default;
					$toggleButtonTextActiveColor:$primaryTextColor !default;
					$toggleButtonIconActiveColor:$primaryTextColor !default;
					$toggleButtonActiveHoverBg:$primaryDarkColor !default;
					$toggleButtonActiveHoverBorderColor:$primaryDarkColor !default;
					$toggleButtonTextActiveHoverColor:$primaryTextColor !default;
					$toggleButtonIconActiveHoverColor:$primaryTextColor !default; //inplace
					$inplacePadding:$inputPadding !default; $inplaceHoverBg:$shade200 !default;
					$inplaceTextHoverColor:$shade700 !default; //rating $ratingIconFontSize:1.143rem !default;
					$ratingCancelIconColor:#ea5455 !default; $ratingCancelIconHoverColor:#e73d3e !default;
					$ratingStarIconOffColor:$shade700 !default; $ratingStarIconOnColor:$primaryColor !default;
					$ratingStarIconHoverColor:$primaryColor !default; //slider $sliderBg:$shade300 !default;
					$sliderBorder:0 none !default; $sliderHorizontalHeight:.286rem !default;
					$sliderVerticalWidth:0.286rem !default; $sliderHandleWidth:1.143rem !default;
					$sliderHandleHeight:1.143rem !default; $sliderHandleBg:$shade000 !default; $sliderHandleBorder:2px
					solid $primaryColor !default; $sliderHandleBorderRadius:50% !default;
					$sliderHandleHoverBorderColor:$primaryColor !default; $sliderHandleHoverBg:$primaryColor !default;
					$sliderRangeBg:$primaryColor !default; //calendar $calendarTableMargin:.5rem 0 !default;
					$calendarPadding:.5rem !default; $calendarBg:linear-gradient(90deg, $primaryColor 0%,
					scale-color($primaryColor, $red: 25%) 100%) !default; $calendarInlineBg:$calendarBg !default;
					$calendarTextColor:$primaryTextColor !default; $calendarBorder:0 none !default;
					$calendarOverlayBorder:$inputOverlayBorder !default; $calendarHeaderPadding:.5rem !default;
					$calendarHeaderBg:transparent !default; $calendarInlineHeaderBg:$calendarBg !default;
					$calendarHeaderBorder:1px solid rgba(255,255,255,.2) !default;
					$calendarHeaderTextColor:$primaryTextColor !default; $calendarHeaderFontWeight:700 !default;
					$calendarHeaderCellPadding:.5rem !default; $calendarCellDatePadding:.5rem !default;
					$calendarCellDateWidth:2.5rem !default; $calendarCellDateHeight:2.5rem !default;
					$calendarCellDateBorderRadius:50% !default; $calendarCellDateBorder:1px solid transparent !default;
					$calendarCellDateHoverBg:rgba(255,255,255,.2) !default;
					$calendarCellDateTodayBg:rgba(255,255,255,.1) !default;
					$calendarCellDateTodayBorderColor:transparent !default;
					$calendarCellDateTodayTextColor:$primaryTextColor !default; $calendarButtonBarPadding:1rem 0
					!default; $calendarTimePickerPadding:.5rem !default; $calendarTimePickerElementPadding:0 .5rem
					!default; $calendarTimePickerTimeFontSize:1.25rem !default; $calendarBreakpoint:769px !default;
					$calendarCellDatePaddingSM:0 !default; //input switch $inputSwitchWidth:3rem !default;
					$inputSwitchHeight:1.75rem !default; $inputSwitchBorderRadius:30px !default;
					$inputSwitchHandleWidth:1.250rem !default; $inputSwitchHandleHeight:1.250rem !default;
					$inputSwitchHandleBorderRadius:50% !default; $inputSwitchSliderPadding:.25rem !default;
					$inputSwitchSliderOffBg:$shade400 !default; $inputSwitchHandleOffBg:$shade000 !default;
					$inputSwitchSliderOffHoverBg:scale-color($shade400, $lightness: -10%) !default;
					$inputSwitchSliderOnBg:$primaryColor !default; $inputSwitchSliderOnHoverBg:$primaryDarkColor
					!default; $inputSwitchHandleOnBg:$shade000 !default; //panel $panelHeaderBorderColor:$shade300
					!default; $panelHeaderBorder:1px solid $shade300 !default; $panelHeaderBg:$shade100 !default;
					$panelHeaderTextColor:$shade600 !default; $panelHeaderFontWeight:700 !default;
					$panelHeaderPadding:1.25rem !default; $panelToggleableHeaderPadding:.75rem 1.25rem !default;
					$panelHeaderHoverBg:$shade200 !default; $panelHeaderHoverBorderColor:$shade300 !default;
					$panelHeaderTextHoverColor:$shade600 !default; $panelContentBorderColor: $shade300 !default;
					$panelContentBorder:1px solid $shade300 !default; $panelContentBg:$shade000 !default;
					$panelContentTextColor:$shade700 !default; $panelContentPadding:1.25rem !default;
					$panelFooterBorder:1px solid $shade300 !default; $panelFooterBg:$shade000 !default;
					$panelFooterTextColor:$shade700 !default; $panelFooterPadding:0.75rem 1.25rem !default; //accordion
					$accordionSpacing:4px !default; $accordionHeaderBorder:$panelHeaderBorder !default;
					$accordionHeaderBg:$panelHeaderBg !default; $accordionHeaderTextColor:$panelHeaderTextColor
					!default; $accordionHeaderFontWeight:$panelHeaderFontWeight !default;
					$accordionHeaderPadding:$panelHeaderPadding !default; $accordionHeaderHoverBg:$shade200 !default;
					$accordionHeaderHoverBorderColor:$shade300 !default;
					$accordionHeaderTextHoverColor:$panelHeaderTextColor !default;
					$accordionHeaderActiveBg:$panelHeaderBg !default; $accordionHeaderActiveBorderColor:$shade300
					!default; $accordionHeaderTextActiveColor:$shade700 !default;
					$accordionHeaderActiveHoverBg:$shade200 !default; $accordionHeaderActiveHoverBorderColor:$shade300
					!default; $accordionHeaderTextActiveHoverColor:$shade700 !default;
					$accordionContentBorder:$panelContentBorder !default; $accordionContentBg:$panelContentBg !default;
					$accordionContentTextColor:$panelContentTextColor !default;
					$accordionContentPadding:$panelContentPadding !default; //tabview $tabviewNavBorder:1px solid
					$shade300 !default; $tabviewNavBorderWidth:0 0 2px 0 !default; $tabviewNavBg:$shade000 !default;
					$tabviewHeaderSpacing:0 !default; $tabviewHeaderBorder:solid $shade300 !default;
					$tabviewHeaderBorderWidth:0 0 2px 0 !default; $tabviewHeaderBorderColor:transparent transparent
					$shade300 transparent !default; $tabviewHeaderBg:$shade000 !default;
					$tabviewHeaderTextColor:$shade600 !default; $tabviewHeaderFontWeight:$panelHeaderFontWeight
					!default; $tabviewHeaderPadding:$panelHeaderPadding !default; $tabviewHeaderMargin:0 0 -2px 0
					!default; $tabviewHeaderHoverBg:$shade000 !default; $tabviewHeaderHoverBorderColor:$shade500
					!default; $tabviewHeaderTextHoverColor:$shade600 !default; $tabviewHeaderActiveBg:$shade000
					!default; $tabviewHeaderActiveBorderColor:$primaryColor !default;
					$tabviewHeaderTextActiveColor:$primaryColor !default; $tabviewContentBorder:0 none !default;
					$tabviewContentBg:$panelContentBg !default; $tabviewContentTextColor:$panelContentTextColor
					!default; $tabviewContentPadding:$panelContentPadding !default; //upload
					$fileUploadProgressBarHeight:.25rem !default; $fileUploadContentPadding:2rem 1rem !default;
					//scrollpanel $scrollPanelTrackBorder:0 none !default; $scrollPanelTrackBg:$shade100 !default;
					//card $cardBodyPadding:1.25rem !default; $cardTitleFontSize:1.5rem !default;
					$cardTitleFontWeight:700 !default; $cardSubTitleFontWeight:400 !default;
					$cardSubTitleColor:$shade600 !default; $cardContentPadding:1.25rem 0 !default;
					$cardFooterPadding:1.25rem 0 0 0 !default; $cardShadow:0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0
					rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12) !default; //editor $editorToolbarBg:$panelHeaderBg
					!default; $editorToolbarBorder:$panelHeaderBorder !default;
					$editorToolbarPadding:$panelHeaderPadding !default; $editorToolbarIconColor:$textSecondaryColor
					!default; $editorToolbarIconHoverColor:$textColor !default; $editorIconActiveColor:$primaryColor
					!default; $editorContentBorder:$panelContentBorder !default; $editorContentBg:$panelContentBg
					!default; //paginator $paginatorBg:$shade000 !default; $paginatorTextColor:$shade600 !default;
					$paginatorBorder:solid $shade200 !default; $paginatorBorderWidth:0 !default; $paginatorPadding:.5rem
					1rem !default; $paginatorElementWidth:$buttonIconOnlyWidth !default;
					$paginatorElementHeight:$buttonIconOnlyWidth !default; $paginatorElementBg:transparent !default;
					$paginatorElementBorder:0 none !default; $paginatorElementIconColor:$shade600 !default;
					$paginatorElementHoverBg:$shade200 !default; $paginatorElementHoverBorderColor:transparent !default;
					$paginatorElementIconHoverColor:$shade700 !default; $paginatorElementBorderRadius:50% !default;
					$paginatorElementMargin:.143rem !default; $paginatorElementPadding:0 !default; //table
					$tableHeaderBorder:1px solid $shade300 !default; $tableHeaderBorderWidth:1px 0 1px 0 !default;
					$tableHeaderBg:$shade100 !default; $tableHeaderTextColor:$shade600 !default;
					$tableHeaderFontWeight:700 !default; $tableHeaderPadding:1rem 1rem !default;
					$tableHeaderCellPadding:1rem 1rem !default; $tableHeaderCellBg:$shade100 !default;
					$tableHeaderCellTextColor:$shade600 !default; $tableHeaderCellFontWeight:700 !default;
					$tableHeaderCellBorder:1px solid $shade300 !default; $tableHeaderCellBorderWidth:0 0 1px 0 !default;
					$tableHeaderCellHoverBg:$shade200 !default; $tableHeaderCellTextHoverColor:$shade600 !default;
					$tableHeaderCellIconColor:$shade600 !default; $tableHeaderCellIconHoverColor:$shade600 !default;
					$tableHeaderCellHighlightBg:$highlightBg !default;
					$tableHeaderCellHighlightTextColor:$highlightTextColor !default;
					$tableHeaderCellHighlightHoverBg:$highlightBg !default;
					$tableHeaderCellHighlightTextHoverColor:$highlightTextColor !default;
					$tableSortableColumnBadgeSize:1.143rem !default; $tableBodyRowBg:$shade000 !default;
					$tableBodyRowTextColor:$shade700 !default; $tableBodyRowEvenBg:scale-color($tableBodyRowBg,
					$lightness: -1%) !default; $tableBodyRowHoverBg:$shade200 !default;
					$tableBodyRowTextHoverColor:$shade700 !default; $tableBodyCellBorder:1px solid $shade300 !default;
					$tableBodyCellBorderWidth:0 0 1px 0 !default; $tableBodyCellPadding:1rem 1rem !default;
					$tableFooterCellPadding:1rem 1rem !default; $tableFooterCellBg:$shade100 !default;
					$tableFooterCellTextColor:$shade600 !default; $tableFooterCellFontWeight:700 !default;
					$tableFooterCellBorder:1px solid $shade300 !default; $tableFooterCellBorderWidth:0 0 1px 0 !default;
					$tableResizerHelperBg:$primaryColor !default; $tableFooterBorder:1px solid $shade300 !default;
					$tableFooterBorderWidth:0 0 1px 0 !default; $tableFooterBg:$shade100 !default;
					$tableFooterTextColor:$shade600 !default; $tableFooterFontWeight:700 !default;
					$tableFooterPadding:1rem 1rem !default; $tableCellContentAlignment:left !default;
					$tableTopPaginatorBorderWidth:0 0 1px 0 !default; $tableBottomPaginatorBorderWidth:0 0 1px 0
					!default; $tableScaleSM:0.5 !default; $tableScaleLG:1.25 !default; //dataview
					$dataViewContentPadding:0 !default; $dataViewContentBorder:0 none !default;
					$dataViewListItemBorder:solid $shade300 !default; $dataViewListItemBorderWidth:0 0 1px 0 !default;
					//schedule $fullCalendarEventBg:$primaryDarkColor !default; $fullCalendarEventBorderColor:
					$primaryDarkColor !default; $fullCalendarEventBorder:1px solid $primaryDarkColor !default;
					$fullCalendarEventTextColor:$primaryTextColor !default; //tree $treeContainerPadding:0.286rem
					!default; $treeNodePadding:0.143rem !default; $treeNodeContentPadding:.5rem !default;
					$treeNodeChildrenPadding:0 0 0 1rem !default; $treeNodeIconColor:$shade600 !default; //timeline
					$timelineVerticalEventContentPadding:0 1rem !default; $timelineHorizontalEventContentPadding:1rem 0
					!default; $timelineEventMarkerWidth:1rem !default; $timelineEventMarkerHeight:1rem !default;
					$timelineEventMarkerBorderRadius:50% !default; $timelineEventMarkerBorder:2px solid $primaryColor
					!default; $timelineEventMarkerBackground:$primaryTextColor !default; $timelineEventConnectorSize:2px
					!default; $timelineEventColor:$shade300 !default; //org chart
					$organizationChartConnectorColor:$shade300 !default; //message $messageMargin:1rem 0 !default;
					$messagePadding:1.25rem 1.75rem !default; $messageBorderWidth:0 0 0 6px !default;
					$messageIconFontSize:1.5rem !default; $messageTextFontSize:1rem !default; $messageTextFontWeight:400
					!default; //inline message $inlineMessagePadding:$inputPadding !default; $inlineMessageMargin:0
					!default; $inlineMessageIconFontSize:1rem !default; $inlineMessageTextFontSize:1rem !default;
					$inlineMessageBorderWidth:0px !default; //toast $toastIconFontSize:2rem !default;
					$toastMessageTextMargin:0 0 0 1rem !default; $toastMargin:0 0 1rem 0 !default; $toastPadding:1rem
					!default; $toastBorderWidth:0 0 0 6px !default; $toastShadow:0 2px 12px 0 rgba(0,0,0,.1) !default;
					$toastOpacity:.9 !default; $toastTitleFontWeight:700 !default; $toastDetailMargin:$inlineSpacing 0 0
					0 !default; //severities $infoMessageBg:#e9e9ff !default; $infoMessageBorder:solid #696cff !default;
					$infoMessageTextColor:#696cff !default; $infoMessageIconColor:#696cff !default;
					$successMessageBg:#e4f8f0 !default; $successMessageBorder:solid #1ea97c !default;
					$successMessageTextColor:#1ea97c !default; $successMessageIconColor:#1ea97c !default;
					$warningMessageBg:#fff2e2 !default; $warningMessageBorder:solid #cc8925 !default;
					$warningMessageTextColor:#cc8925 !default; $warningMessageIconColor:#cc8925 !default;
					$errorMessageBg:#ffe7e6 !default; $errorMessageBorder:solid #ff5757 !default;
					$errorMessageTextColor:#ff5757 !default; $errorMessageIconColor:#ff5757 !default; //overlays
					$overlayContentBorder:0 none !default; $overlayContentBg:$panelContentBg !default;
					$overlayContainerShadow:0 1px 3px rgba(0,0,0,.3) !default; //dialog $dialogHeaderBg:$shade000
					!default; $dialogHeaderBorder:0 none !default; $dialogHeaderTextColor:$shade600 !default;
					$dialogHeaderFontWeight:700 !default; $dialogHeaderFontSize:1.25rem !default;
					$dialogHeaderPadding:1.5rem !default; $dialogContentPadding:0 1.5rem 2rem 1.5rem !default;
					$dialogFooterBorder:0 none !default; $dialogFooterPadding:0 1.5rem 1.5rem 1.5rem !default;
					//confirmpopup $confirmPopupContentPadding:$panelContentPadding !default;
					$confirmPopupFooterPadding:0 1.25rem 1.25rem 1.25rem !default; //tooltip $tooltipBg:$shade700
					!default; $tooltipTextColor:$shade000 !default; $tooltipPadding:$inputPadding !default; //steps
					$stepsItemBg:$shade000 !default; $stepsItemBorder:1px solid $shade200 !default;
					$stepsItemTextColor:$shade600 !default; $stepsItemNumberWidth:2rem !default;
					$stepsItemNumberHeight:2rem !default; $stepsItemNumberFontSize:1.143rem !default;
					$stepsItemNumberColor:$shade700 !default; $stepsItemNumberBorderRadius:50% !default;
					$stepsItemActiveFontWeight:700 !default; //progressbar $progressBarHeight:1.5rem !default;
					$progressBarBorder:0 none !default; $progressBarBg:$shade300 !default;
					$progressBarValueBg:$primaryColor !default; //menu (e.g. menu, menubar, tieredmenu)
					$menuWidth:12.5rem !default; $menuBg:$shade100 !default; $menuBorder:1px solid $shade300 !default;
					$menuTextColor:$shade700 !default; $menuitemPadding:.75rem 1.25rem !default; $menuitemBorderRadius:0
					!default; $menuitemTextColor:$shade700 !default; $menuitemIconColor:$shade600 !default;
					$menuitemTextHoverColor:$shade700 !default; $menuitemIconHoverColor:$shade600 !default;
					$menuitemHoverBg:$shade200 !default; $menuitemTextActiveColor:$highlightTextColor !default;
					$menuitemIconActiveColor:$highlightTextColor !default; $menuitemActiveBg:$highlightBg !default;
					$menuitemSubmenuIconFontSize:.875rem !default; $submenuHeaderMargin:0 !default;
					$submenuHeaderPadding:.75rem 1.25rem !default; $submenuHeaderBg:$shade100 !default;
					$submenuHeaderTextColor:$shade600 !default; $submenuHeaderBorderRadius:0 !default;
					$submenuHeaderFontWeight:700 !default; $overlayMenuBg:$menuBg !default; $overlayMenuBorder:0 none
					!default; $overlayMenuShadow:0 2px 12px 0 rgba(0,0,0,.1) !default; $verticalMenuPadding:.25rem 0
					!default; $verticalMenuitemMargin:0 !default; $menuSeparatorMargin:.25rem 0 !default;
					$breadcrumbPadding:1rem !default; $breadcrumbBg:$menuBg !default; $breadcrumbBorder:$menuBorder
					!default; $breadcrumbItemTextColor:$menuitemTextColor !default;
					$breadcrumbItemIconColor:$menuitemIconColor !default;
					$breadcrumbLastItemTextColor:$menuitemTextColor !default;
					$breadcrumbLastItemIconColor:$menuitemIconColor !default;
					$breadcrumbSeparatorColor:$menuitemTextColor !default; $horizontalMenuPadding:.5rem !default;
					$horizontalMenuBg:$shade100 !default; $horizontalMenuBorder:$menuBorder !default;
					$horizontalMenuTextColor:$menuTextColor !default;
					$horizontalMenuRootMenuitemPadding:$menuitemPadding !default;
					$horizontalMenuRootMenuitemBorderRadius:$borderRadius !default;
					$horizontalMenuRootMenuitemTextColor:$menuitemTextColor !default;
					$horizontalMenuRootMenuitemIconColor:$menuitemIconColor !default;
					$horizontalMenuRootMenuitemTextHoverColor:$menuitemTextHoverColor !default;
					$horizontalMenuRootMenuitemIconHoverColor:$menuitemIconHoverColor !default;
					$horizontalMenuRootMenuitemHoverBg:$menuitemHoverBg !default;
					$horizontalMenuRootMenuitemTextActiveColor:$menuitemTextActiveColor !default;
					$horizontalMenuRootMenuitemIconActiveColor:$menuitemIconActiveColor !default;
					$horizontalMenuRootMenuitemActiveBg:$menuitemActiveBg !default; //badge and tag
					$badgeBg:$primaryColor !default; $badgeTextColor:$primaryTextColor !default; $badgeMinWidth:1.5rem
					!default; $badgeHeight:1.5rem !default; $badgeFontWeight:700 !default; $badgeFontSize:.75rem
					!default; $tagPadding:.25rem .4rem !default; //carousel $carouselIndicatorsPadding:1rem !default;
					$carouselIndicatorBg:$shade400 !default; $carouselIndicatorHoverBg:$shade500 !default;
					$carouselIndicatorBorderRadius:0 !default; $carouselIndicatorWidth:2rem !default;
					$carouselIndicatorHeight:.5rem !default; //galleria $galleriaMaskBg:rgba(0,0,0,0.9) !default;
					$galleriaCloseIconMargin:.5rem !default; $galleriaCloseIconFontSize:2rem !default;
					$galleriaCloseIconBg:transparent !default; $galleriaCloseIconColor:$shade100 !default;
					$galleriaCloseIconHoverBg:rgba(255,255,255,0.1) !default; $galleriaCloseIconHoverColor:$shade100
					!default; $galleriaCloseIconWidth:4rem !default; $galleriaCloseIconHeight:4rem !default;
					$galleriaCloseIconBorderRadius:50% !default; $galleriaItemNavigatorBg:transparent !default;
					$galleriaItemNavigatorColor:$shade100 !default; $galleriaItemNavigatorMargin:0 .5rem !default;
					$galleriaItemNavigatorFontSize:2rem !default; $galleriaItemNavigatorHoverBg:rgba(255,255,255,0.1)
					!default; $galleriaItemNavigatorHoverColor:$shade100 !default; $galleriaItemNavigatorWidth:4rem
					!default; $galleriaItemNavigatorHeight:4rem !default;
					$galleriaItemNavigatorBorderRadius:$borderRadius !default; $galleriaCaptionBg:rgba(0,0,0,.5)
					!default; $galleriaCaptionTextColor:$shade100 !default; $galleriaCaptionPadding:1rem !default;
					$galleriaIndicatorsPadding:1rem !default; $galleriaIndicatorBg:$shade400 !default;
					$galleriaIndicatorHoverBg:$shade500 !default; $galleriaIndicatorBorderRadius:50% !default;
					$galleriaIndicatorWidth:1rem !default; $galleriaIndicatorHeight:1rem !default;
					$galleriaIndicatorsBgOnItem:rgba(0,0,0,.5) !default; $galleriaIndicatorBgOnItem:rgba(255,255,255,.4)
					!default; $galleriaIndicatorHoverBgOnItem:rgba(255,255,255,.6) !default;
					$galleriaThumbnailContainerBg:rgba(0,0,0,.9) !default; $galleriaThumbnailContainerPadding:1rem
					.25rem !default; $galleriaThumbnailNavigatorBg:transparent !default;
					$galleriaThumbnailNavigatorColor:$shade100 !default;
					$galleriaThumbnailNavigatorHoverBg:rgba(255,255,255,0.1) !default;
					$galleriaThumbnailNavigatorHoverColor:$shade100 !default;
					$galleriaThumbnailNavigatorBorderRadius:50% !default; $galleriaThumbnailNavigatorWidth:2rem
					!default; $galleriaThumbnailNavigatorHeight:2rem !default; //divider
					$dividerHorizontalMargin:1.25rem 0 !default; $dividerHorizontalPadding:0 1.25rem !default;
					$dividerVerticalMargin:0 1.25rem !default; $dividerVerticalPadding:1.25rem 0 !default;
					$dividerSize:1px !default; $dividerColor:$shade300 !default; //avatar $avatarBg:$shade300 !default;
					$avatarTextColor:$textColor !default; //chip $chipBg:$shade300 !default; $chipTextColor:$textColor
					!default; $chipBorderRadius: 16px !default; //scrollTop $scrollTopBg:rgba(0,0,0,0.7) !default;
					$scrollTopHoverBg:rgba(0,0,0,0.8) !default; $scrollTopWidth:3rem !default; $scrollTopHeight:3rem
					!default; $scrollTopBorderRadius:50% !default; $scrollTopFontSize:1.5rem !default;
					$scrollTopTextColor:$shade100 !default; //skeleton $skeletonBg:$shade300 !default;
					$skeletonAnimationBg:rgba(255,255,255,0.4) !default; //splitter $splitterGutterBg:$shade100
					!default; $splitterGutterHandleBg:$shade300 !default; //speeddial $speedDialButtonWidth: 4rem
					!default; $speedDialButtonHeight: 4rem !default; $speedDialButtonIconFontSize: 1.3rem !default;
					$speedDialActionWidth: 3rem !default; $speedDialActionHeight: 3rem !default; $speedDialActionBg:
					$shade700 !default; $speedDialActionHoverBg: #022354 !default; $speedDialActionTextColor: #fff
					!default; $speedDialActionTextHoverColor: #fff !default; //dock $dockActionWidth: 4rem !default;
					$dockActionHeight: 4rem !default; $dockItemPadding: .5rem !default; $dockCurrentItemMargin: 1.5rem
					!default; $dockFirstItemsMargin: 1.3rem !default; $dockSecondItemsMargin: 0.9rem !default; $dockBg:
					rgba(255,255,255,.1) !default; $dockBorder: 1px solid rgba(255,255,255,0.2) !default; $dockPadding:
					.5rem .5rem !default; $dockBorderRadius: .5rem !default; //image $imageMaskBg:rgba(0,0,0,0.9)
					!default; $imagePreviewToolbarPadding:1rem !default; $imagePreviewIndicatorColor:#f8f9fa !default;
					$imagePreviewIndicatorBg:rgba(0,0,0,0.5) !default; $imagePreviewActionIconBg:transparent !default;
					$imagePreviewActionIconColor:#f8f9fa !default; $imagePreviewActionIconHoverBg:rgba(255,255,255,0.1)
					!default; $imagePreviewActionIconHoverColor:#f8f9fa !default; $imagePreviewActionIconWidth:3rem
					!default; $imagePreviewActionIconHeight:3rem !default; $imagePreviewActionIconFontSize:1.5rem
					!default; $imagePreviewActionIconBorderRadius:50% !default; :root &#123;
					--surface-a:#&#123;$shade000&#125;; --surface-b:#&#123;$shade100&#125;;
					--surface-c:#&#123;$shade200&#125;; --surface-d:#&#123;$shade300&#125;;
					--surface-e:#&#123;$shade000&#125;; --surface-f:#&#123;$shade000&#125;;
					--text-color:#&#123;$shade700&#125;; --text-color-secondary:#&#123;$shade600&#125;;
					--primary-color:#&#123;$primaryColor&#125;; --primary-color-text:#&#123;$primaryTextColor&#125;;
					--font-family:#&#123;$fontFamily&#125;; --surface-0: #ffffff; --surface-50: #f1f4f6; --surface-100:
					#e2e8ee; --surface-200: #c6d1dd; --surface-300: #a9bbcb; --surface-400: #8da4ba; --surface-500:
					#708da9; --surface-600: #5a7187; --surface-700: #435565; --surface-800: #2d3844; --surface-900:
					#161c22; --gray-50: #f1f4f6; --gray-100: #e2e8ee; --gray-200: #c6d1dd; --gray-300: #a9bbcb;
					--gray-400: #8da4ba; --gray-500: #708da9; --gray-600: #5a7187; --gray-700: #435565; --gray-800:
					#2d3844; --gray-900: #161c22; --content-padding:#&#123;$panelContentPadding&#125;;
					--inline-spacing:#&#123;$inlineSpacing&#125;; --border-radius:#&#123;$borderRadius&#125;;
					--surface-ground:#eff3f8; --surface-section:#ffffff; --surface-card:#ffffff;
					--surface-overlay:#ffffff; --surface-border:#dfe7ef; --surface-hover:#f6f9fc; &#125;
				</app-code>
			</div>

			<h4>Menu Modes</h4>
			<p>
				Menu has 2 modes, static and slim. Layout container element in application.html is used to define which
				mode to use by adding specific classes. List below indicates the style classes for each mode. In
				addition menu
			</p>
			<ul>
				<li>Static: "layout-wrapper layout-static"</li>
				<li>Slim: "layout-wrapper layout-slim"</li>
			</ul>

			<p>For example to create a slim menu, the div element should be in following form;</p>
			<app-code ngPreserveWhitespaces ngNonBindable lang="javascript">
				&lt;div class="layout-wrapper layout-slim"&gt;
			</app-code>

			<p>
				It is also possible to leave the choice to the user by keeping the preference at a component and using
				an ngClass expression so that user can switch between modes. Sample application has an example
				implementation of such use case. Refer to app.component.ts for an example.
			</p>

			<h4>Grid CSS</h4>
			<p>
				Verona uses PrimeNG Flex Grid CSS throughout the demos such as Dashboard, however any Grid library can
				be used with it since Verona Layout itself does not depend on PrimeFlex CSS.
			</p>

			<h4>Customizing Styles</h4>
			<p>
				It is suggested to add your customizations in the following sass files under the override folder instead
				of adding them to the scss files under sass folder to avoid maintenance issues after an update.
			</p>

			<ul>
				<li><b>_layout_variables</b>: Variables of the layout.</li>
				<li><b>_layout_styles</b>: Styles for the layout.</li>
				<li><b>_theme_variables</b>: Variables of the theme.</li>
				<li><b>_theme_styles</b>: Styles for the theme.</li>
			</ul>

			<h4>Migration Guide</h4>
			<p>
				Every change is included in <b>CHANGELOG.md</b> file at the root folder of the distribution along with
				the instructions to update.
			</p>
		</div>
	</div>
</div>
